export default {"src":"/_next/static/media/33.9de59fd3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};